const parseForSelect = data => data?.map(({name: label, alpha2: value}) => ({label, value}))

export const getCountries = state => parseForSelect(state?.configuration?.countries || [])
export const getTermsURL = state => state?.configuration?.urls?.terms_url
export const getPaymentsActive = state => state?.configuration?.payments_active
export const getSupportEmail = state => state?.configuration?.support_email
